import { FetchLicenseFailedEvent, FetchLicenseSuccessEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { getLicenseInformation } from '@atlassian/mpac-api-client';
import { useMarketplaceCrossFlow } from '@atlassian/mpac-primitives';
import { hooks } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
const getUnlicensedAtlassianProducts = async (mpacBaseUrl, cloudId, crossFlowProducts, fireSuccessEvent, fireFailureEvent) => {
  const licenseInformation = await getLicenseInformation(mpacBaseUrl, cloudId, fireSuccessEvent, fireFailureEvent);
  return crossFlowProducts.filter(product => {
    var _licenseInformation$p;
    return (licenseInformation === null || licenseInformation === void 0 ? void 0 : (_licenseInformation$p = licenseInformation.products[product.targetProduct]) === null || _licenseInformation$p === void 0 ? void 0 : _licenseInformation$p.state) !== 'ACTIVE';
  });
};
const useGetUnlicensedAtlassianProducts = cloudId => {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    crossFlowProducts
  } = useMarketplaceCrossFlow();

  // Only fetch if all required conditions are met
  const shouldFetch = !!(!!crossFlowProducts.length && cloudId);
  const fireSuccessEvent = () => {
    fireAnalyticsEvent({
      eventType: FetchLicenseSuccessEvent
    });
  };
  const fireFailureEvent = () => {
    fireAnalyticsEvent({
      eventType: FetchLicenseFailedEvent
    });
  };
  const unlicensedAtlassianProductsPromise = useCallback(async () => {
    if (!cloudId) {
      return [];
    }
    return getUnlicensedAtlassianProducts('', cloudId, crossFlowProducts, fireSuccessEvent, fireFailureEvent);
  }, [crossFlowProducts, cloudId, fireSuccessEvent, fireFailureEvent]);
  const {
    result: unlicensedAtlassianProducts,
    pending: loading
  } = hooks.usePromise(unlicensedAtlassianProductsPromise, [cloudId], shouldFetch);
  return {
    unlicensedAtlassianProducts: unlicensedAtlassianProducts || [],
    loading
  };
};
export default useGetUnlicensedAtlassianProducts;